import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";

import MainNavigation from "../components/MainNavigation";
import PageContent from "../components/PageContent";
import LogoSmall from "../svg/logo-small";

import { DatoHelmet } from "../components/DatoHelmet";
import { TransitionGroup } from "react-transition-group";

import "./index.scss";

import fb from "../svg/fb";
import insta from "../svg/insta";

const openModalEventType = `modal::open`;

const getNonBreakingTitle = title => {
  return title.split(" ").join(`&nbsp;`);
};

class TemplateWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = { modalContent: null, modalOpen: false };
  }
  componentDidMount() {
    if (typeof window === "undefined") return;
    window.addEventListener(openModalEventType, this.openModal.bind(this));
    if (window.emitter) {
      this.resetImagesLoaded();
      window.emitter.on("imageLoaded", this.onImageLoaded);

      if (!this.images || this.images.length === 0) {
        this.animateIn();
      }
    }
  }

  resetImagesLoaded() {
    this.imagesLoaded = 0;
    this.images = document.querySelectorAll(".is-page img");
  }

  onImageLoaded = () => {
    console.log("image loaded");
    this.imagesLoaded++;
    if (this.imagesLoaded >= 1) {
      this.animateIn();
    }
  };

  animateIn() {
    window.emitter.off("imageLoaded", this.onImageLoaded);
    if (!document.body.classList.contains("is-loaded")) {
      document.body.classList.add("is-loaded");
    }

    if (!this.overlay) {
      return;
    }

    TweenMax.to(this.overlay.querySelector("svg"), 0.3, {
      autoAlpha: 0,
      y: `+=10px`,
      ease: Sine.easeOut,
      delay: 0.3
    });

    TweenMax.to(this.overlay, 0.3, {
      autoAlpha: 0,
      ease: Sine.easeOut,
      delay: 0.6,
      onComplete: () => {
        this.overlay.parentNode.removeChild(this.overlay);
      }
    });
  }

  componentWillUnmount() {
    if (typeof window === "undefined") return;
    window.removeEventListener(openModalEventType, this.openModal.bind(this));
  }

  componentDidUpdate() {
    this.resetImagesLoaded();
  }

  openModal(e) {
    const { pathname, data } = e.detail;
    /*if (pathname === this.props.location.pathname) {
      TweenMax.to(window, 3, {
        scrollTo: { y: 0, autoKill: false },
        ease: Sine.easeOut
      });
      return;
    }*/

    this.setState(
      { ...this.state, modalOpen: true, modalContent: data },
      () => {
        if (!document.body.classList.contains("has-modal")) {
          document.body.classList.add("has-modal");
        }
        TweenMax.from(document.querySelector(".modal"), 0.4, {
          autoAlpha: 0,
          ease: Sine.easeOut
        });
      }
    );
  }

  closeModal() {
    TweenMax.to(document.querySelector(".modal"), 0.2, {
      autoAlpha: 0,
      ease: Sine.easeIn,
      onComplete: () => {
        this.setState({ ...this.state, modalOpen: false }, () => {
          document.body.classList.remove("has-modal");
          TweenMax.set(document.querySelector(".modal"), { autoAlpha: 1 });
        });
      }
    });
  }

  renderModalContent({ modalOpen, modalContent }) {
    if (modalOpen) {
      return <PageContent {...modalContent} />;
    }
    return null;
  }

  renderOverlay() {
    if (typeof window === "undefined") {
      this.overlay = null;
      return null;
    }

    return (
      <div
        ref={overlay => (this.overlay = overlay)}
        className="is-loading-overlay"
      >
        <LogoSmall className="is-logo" animationDelay={0.4} />
      </div>
    );
  }

  render() {
    const { children, data, location } = this.props;
    const { modalContent, modalOpen } = this.state;
    const locale = location.pathname.indexOf("fr") === 1 ? "fr" : "en";
    const nav = data[`nav_${locale}`];
    const datoCmsHomePage = data[`datoCmsHomePage_${locale}`];
    const pageId = datoCmsHomePage.id;
    const footer = data[`footer_${locale}`];

    const modalActiveClass = modalOpen ? " is-active" : "";

    return (
      <div>
        <DatoHelmet
          favicon={data.datoCmsSite.faviconMetaTags}
          seo={datoCmsHomePage.seoMetaTags}
        >
          <html lang={locale} className={`${locale}`} />
          <noscript>
            {`<style
              type="text/css"
            >
            main, .footer{visibility:visible !important}
            </style>`}
          </noscript>
        </DatoHelmet>
        <header>
          <MainNavigation
            locale={locale}
            path={location.pathname}
            nav={nav}
            pageId={pageId}
            homeSlug={datoCmsHomePage.slug}
          />
        </header>
        {this.renderOverlay()}
        {children()}
        <footer className="footer">
          <div className="container">
            <div className="columns is-mobile is-multiline is-centered">
              <div className="column is-12">
                <div className="level">
                  <div className="level-left social">
                    <a
                      href="https://www.instagram.com/miniheroes_fashion/"
                      target="_blank"
                      title="Instagram"
                    >
                      {insta}
                    </a>
                    {/*<a href="#">{fb}</a>*/}
                  </div>
                  <div className="level-right">
                    {footer.links.map(({ id, title, slug }, index) => (
                      <Link
                        key={id}
                        title={title}
                        to={`/${slug}`}
                        dangerouslySetInnerHTML={{
                          __html: getNonBreakingTitle(title)
                        }}
                      />
                    ))}
                    <div className="info">
                      <h5 className="has-text-weight-bold">
                        {footer.trademark}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className={`modal is-page-modal${modalActiveClass}`}>
          <div className="modal-background" />
          <div className="modal-content">
            {this.renderModalContent({ modalOpen, modalContent })}
            <button
              className="modal-close is-large"
              aria-label="close"
              onClick={this.closeModal.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;

export const query = graphql`
  query LayoutQuery {
    datoCmsSite {
      globalSeo {
        siteName
      }
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    datoCmsHomePage_en: datoCmsPage(slug: { eq: "" }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }

    datoCmsHomePage_fr: datoCmsPage(slug: { eq: "fr" }) {
      slug
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }

    nav_en: datoCmsMainNavigation {
      links {
        label
        id
        link {
          slug
        }
      }
    }

    nav_fr: datoCmsMainNavigation(locale: { eq: "fr" }) {
      links {
        id
        label
        link {
          slug
        }
      }
    }

    footer_en: datoCmsFooter {
      trademark
      links {
        id
        title
        slug
      }
    }

    footer_fr: datoCmsFooter(locale: { eq: "fr" }) {
      trademark
      links {
        id
        title
        slug
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js